<ng-container *ngFor="let menuItem of applicationMenuSpec; trackBy: trackById">
  <div #accordionHeader (click)="loadMenu($event, menuItem)" class="accordion-header" attr.id="{{menuIdV1(menuItem)}}" [attr.menuIndex]="menuItem.menuIndex" [attr.selected]="menuItem.selected">
    <!--
      do we need an id just for hte expander since clicking anywhere will trigger the expansion
      attr.id="{{menuItem.id}}_expander"
    -->
    <button *ngIf="menuItem.menu" class="btn hide-focus" type="button" (click)="loadMenu($event, menuItem)">
      <span class="icon plus-minus" aria-hidden="true" role="presentation"></span>
    </button>
    <!-- must use href="#" here so that soho will handle expanding a sub menu when clicking on the text -->
    <a class="router-link-active"
       href="#"
       attr.data-automation-id="{{dataAutomationId(menuItem)}}"
       attr.id="{{menuIdV2(menuItem)}}"
       (click)="onMenuItemClicked($event, menuItem)"
       (click)="loadMenu($event, menuItem)"
       (contextmenu)="onMenuItemRightClicked($event, menuItem)"
    >
      <span>{{menuItem?.webAppTitle || menuItem?.label}}</span>
    </a>
  </div>
  <lm-application-menu-submenu
      *ngIf="menuItem.menu"
      class="accordion-pane has-icons"
      [inSearchResultsMenu]="inSearchResultsMenu"
      [applicationMenuSpec]="menuItem.menu"
      (menuLoaded)="onMenuLoaded($event)"
      [attr.link]="menuItem.link">
  </lm-application-menu-submenu>
</ng-container>
<div #menuFormDialog>
  <!-- dialog placeholder used to display action form from menu -->
</div>
